import customAxios from "../../customHook/customAxios";

import { getAuthHeader } from '../../utils';

export const v3_add_leave_application = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/application`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v3_edit_leave_application = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/application`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_applied_leaves = async (page, limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/leave/applied/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}